import React, { useEffect } from 'react'
import moment from 'moment'

import { Box, Grid, Typography } from '@material-ui/core'

import { Barcode } from 'src/components/Barcode'
import { Product } from 'src/api/models'

interface Props {
  product: Product
  measure: number
  unitOfMeasure: string
  onReadyToPrint?: () => void
}

export const MeasureLabel = (props: Props) => {
  const { product, measure, unitOfMeasure, onReadyToPrint } = props
  const encoded = `${product.guid}|${JSON.stringify({
    quantity: measure,
    unit_of_measure: unitOfMeasure,
  })}`
  const barcode = { barcode: encoded, type: 'datamatrix', displayName: '' }

  useEffect(() => {
    onReadyToPrint?.()
  }, [onReadyToPrint])

  return (
    <div className="always-page-break">
      <Box pl={10} pt={20} className="print-page">
        <Grid container justify="center" alignItems="center" spacing={4}>
          <Grid item xs={2}>
            <Barcode barcode={barcode} />
          </Grid>
          <Grid item xs={10} container>
            <Grid item xs={12}>
              <Typography variant="h1">{product.name}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h1">{product.guid}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h1">{`Quantity: ${measure} ${unitOfMeasure}`}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography>Printed on {moment().format('lll')}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </div>
  )
}
